/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
Vue.use(require('vue-moment'));

import VueSweetalert2 from 'vue-sweetalert2';
import JwPagination from 'jw-vue-pagination';

Vue.use(VueSweetalert2);
Vue.component('jw-pagination', JwPagination);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('admins', require('./components/Admin.vue').default);
Vue.component('signature-pad', require('./components/Signature.vue').default);
Vue.component('ajouter-vacataire', require('./components/AjouterVacataire.vue').default);
Vue.component('parametres', require('./components/Parametres.vue').default);
Vue.component('parametres-daf', require('./components/ParametresDaf.vue').default);
Vue.component('questions-refus', require('./components/QuestionsRefus').default);
Vue.component('add-missions', require('./components/Missions.vue').default);
Vue.component('location', require('./components/Location.vue').default);
Vue.component('creer-attestation', require('./components/CreerAttestation.vue').default);
Vue.component('activites', require('./components/Activites.vue').default);
Vue.component('activites-realise', require('./components/ActivitesRealise.vue').default);
Vue.component('historique', require('./components/Historique.vue').default);
Vue.component('acte-engagement', require('./components/ActeEngagement.vue').default);
Vue.component('derogation', require('./components/Derogation.vue').default);
Vue.component('reset-password', require('./components/resetPassword.vue').default);
Vue.component('vacataire-profile', require('./components/VacataireProfile.vue').default);
Vue.component('new-profile', require('./components/NewProfile.vue').default);
Vue.component('profile', require('./components/Profile.vue').default);
Vue.component('ae-chart', require('./components/AE_Chart.vue').default);
Vue.component('nh-chart', require('./components/NH_Chart.vue').default);
Vue.component('edit-vacataire', require('./components/EditVacataire.vue').default);
Vue.component('decharge', require('./components/Decharge.vue').default);
Vue.component('decharge-vacataire', require('./components/DechargeVacataire.vue').default);
Vue.component('vh-permanent', require('./components/VH_permanent.vue').default);
Vue.component('suivi-vh', require('./components/Suivi_VH.vue').default);
Vue.component('declaration-vh-fc', require('./components/Declaration_vh_fc.vue').default);
Vue.component('new-declaration-vh-fc', require('./components/new_declaration_vh_fc.vue').default);
Vue.component('permanent-nh-index', require('./components/PermanentNhIndex.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
